export const SET_SELECTION = 'SET_SELECTION';
export const SET_MODEL = 'SET_MODEL';
export const SET_SELECTION_VALUE = 'SET_SELECTION_VALUE';
export const SET_SELECTION_VALUES = 'SET_SELECTION_VALUES';
export const SET_DATA_MODEL_VALUE = 'SET_DATA_MODEL_VALUE';
export const SET_DATA_MODEL_PACKAGES = 'SET_DATA_MODEL_PACKAGES';
export const SET_DATA_MODEL_MM = 'SET_DATA_MODEL_MM';
export const SET_DATA_MM_SELECTION = 'SET_DATA_MM_SELECTION';
export const SET_PACKAGES = 'SET_PACKAGES';
export const SET_FIELD_VALIDATION = 'SET_FIELD_VALIDATION';
export const RESET = 'RESET';
export const RESET_PACKAGE = 'RESET_PACKAGE';
export const RESET_VEHICLE = 'RESET_VEHICLE';
export const SET_PURCHASE_COMPLETE = 'SET_PURCHASE_COMPLETE';
export const SET_LABELS = 'SET_LABELS';
export const SET_DID_CLICK_FETCH_PACKAGES = 'SET_DID_CLICK_FETCH_PACKAGES';
export const SET_ERROR = 'SET_ERROR';
export const SET_CHILD_LIST_ARRAY = 'SET_CHILD_LIST_ARRAY';
export const CLEAR_STORE = 'CLEAR_STORE';
export const SET_RELOAD_STAKEHOLDER = 'SET_RELOAD_STAKEHOLDER';
export const SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE';
export const SET_SHOULD_CHECK_BBR = 'SET_SHOULD_CHECK_BBR';
export const SET_FIELD_VALIDATIONS = 'SET_FIELD_VALIDATIONS';
export const SET_CHECK_RISC = 'SET_CHECK_RISC';
